import filters from '../../filters'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import ExportButton from '../elements/ExportButton'

export default {
    filters,
    components: { ExportButton },
    created() {
        if (!this.$router) {
            window.onpopstate = (event) => {
                this.softReset();
                this.resolve();
                this.load();
            };
        }
    },
    computed: {
        ...mapState({ 
            isBusy: state => state.dataView.isBusy,
            results: state => state.dataView.resultSet,
            filters: state => state.dataView.currentFilters,
            currentPage: state => state.dataView.currentPage,
            searchTerm: state => state.dataView.searchTerm,
            layout: state => state.dataView.layout,
        }),
        ...mapGetters({
            isFiltered: 'dataView/isFiltered',
            hasResults: 'dataView/hasResults',
            savedViewMenuOptions: 'dataView/savedViewMenuOptions',
            hasMorePages: 'dataView/hasMorePages',
            hasPreviousPages: 'dataView/hasPreviousPages',
        }),
    },
    methods: {
        ...mapActions({ 
            resolve: 'dataView/resolveFiltersAndOrderFromUrl',
            load: 'dataView/get',
            loadAll: 'dataView/getAll',
            loadSavedViews: 'dataView/load', 
            setResourceBase: 'dataView/setResource',
            setResourceAndLoad: 'dataView/setResourceAndLoad',
            softReset: 'dataView/softReset',
            hardReset: 'dataView/hardReset',
            reset: 'dataView/reset',
            setQueryString: 'dataView/setQueryString',
            setViewFromOptionAndLoad: 'dataView/setViewFromOptionAndLoad',
            search: 'dataView/search',
            makeDefault: 'dataView/makeDefault',
            setViewFromOption: 'dataView/setViewFromOption',
        }),
        ...mapMutations({ 
            setResourceRelations: 'dataView/setResourceRelations',
            setDefaultSortOrder: 'dataView/setDefaultSortOrder',
            setAdditionalDefaultParams: 'dataView/setAdditionalDefaultParams',
            setNamespacesToLoad: 'dataView/setNamespacesToLoad',
            setCurrentNamespace: 'dataView/setCurrentNamespace',
            setHasResourceOptions: 'dataView/setHasResourceOptions',
            setFilterOverride: 'dataView/setFilterOverride',
            setFilterOverrides: 'dataView/setFilterOverrides',
            setSortOrder: 'dataView/setSortOrder', 
            setPage: 'dataView/setPage',
            setPerPage: 'dataView/setPerPage',
            setFilter: 'dataView/setFilter',
            removeFilter: 'dataView/removeFilter',
            setFilters: 'dataView/setFilters',
            setDefaultFilter: 'dataView/setDefaultFilter',
            removeDefaultFilter: 'dataView/removeDefaultFilter',
            setDefaultFilters: 'dataView/setDefaultFilters',
            setTitle: 'dataView/setTitle',
            setIsSavedView: 'dataView/setIsSavedView',
            setLayout: 'dataView/setLayout',
            setDefaultLayout: 'dataView/setDefaultLayout',
            setSystemDefaultView: 'dataView/setSystemDefaultView',
            setIsPresetView: 'dataView/setIsPresetView',
        }),
        setResource(resource) {
            return this.setResourceBase({ resource });
        },
        setDefaultViewAndLoad(viewName, resource) {
            if (!getQueryParameterByName('title')) {
                let selectedView = this.viewOptions.find(i => i.label === viewName)

                if (selectedView) {
                    this.setSystemDefaultView({
                        filters: selectedView.filters,
                        sort_order: selectedView.sort
                    })

                    this.setViewFromOption({option: selectedView, load: false})
                }
            }

            return this.setResourceAndLoad(resource);
        },
        viewSelected(option) {
            return this.setViewFromOptionAndLoad(option)
        },
        doExport(i) {
            this.exportTo({ format: i.method })
        }
    },
}